'use client';
import CmsPageRenderer from '@/components/CmsPageRenderer';
import { content } from './_content';

export default function ImpressumPage() {
  return (
    <CmsPageRenderer
      slug="impressum"
      fallbacks={content}
      fallback={{
        title: 'Impressum',
        subtitle: 'Pflichtangaben gemäß EU-Verordnung 2018/302 und estnischem Handelsgesetzbuch (äriseadustik) · Stand: 10.05.2026',
        sections: [
          {
            id: 'company',
            title: 'Diensteanbieter',
            body:
              '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Estland (Estonia)\n\n- **Registrikood (Handelsregisternummer):** 14744075\n- **USt-IdNr. / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Register:** Eesti äriregister (Estnisches Handelsregister)\n- **Unternehmensform:** Osaühing (OÜ) — Gesellschaft mit beschränkter Haftung nach estnischem Recht\n- **Zugelassen und reguliert in:** Republik Estland, Europäische Union',
          },
          {
            id: 'responsible',
            title: 'Inhaltlich Verantwortlicher',
            body:
              '**Andreas A. Gleim**\nGeschäftsführer / Inhaltlich verantwortlich gemäß estnischem Handelsgesetzbuch (äriseadustik) und § 18 MStV (Deutschland)\n\nE-Mail: [logixa.one/kontakt](/kontakt)',
          },
          {
            id: 'contact',
            title: 'Kontakt',
            body:
              'E-Mail: [logixa.one/kontakt](/kontakt)\nWebsite: [https://logixa.one](https://logixa.one)\n\nAnfragen zur Plattform, Partnerschaften, Presse und Datenschutz erreichen uns über das [Kontaktformular](/kontakt).',
          },
          {
            id: 'eu',
            title: 'EU-Streitschlichtung',
            body:
              'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nWir sind weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
          },
          {
            id: 'liability',
            title: 'Haftung für Inhalte',
            body:
              'Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG (Deutschland) und der estnischen InfoTS für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.\n\nVerpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.',
          },
          {
            id: 'liability-links',
            title: 'Haftung für Links',
            body:
              'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
          },
          {
            id: 'copyright',
            title: 'Urheberrecht',
            body:
              'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.\n\nDownloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.',
          },
        ],
      }}
    />
  );
}
